import { useEffect } from 'react';
import { ArrowLeft, Scale } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const LegalNoticePage = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="legal-notice-page">
      <header className="sticky top-0 z-50 glass border-b border-[#2D231E]/10">
        <div className="container-max flex items-center h-16">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-[#5C4D43] hover:text-[#C44536] transition-colors"
            data-testid="back-from-legal"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-sans text-sm font-medium">Volver</span>
          </button>
        </div>
      </header>

      <div className="container-max py-12 max-w-4xl">
        <div className="flex items-center gap-3 mb-8">
          <Scale className="w-8 h-8 text-[#C44536]" />
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#2D231E]">Aviso Legal</h1>
        </div>

        <div className="prose prose-lg font-sans text-[#2D231E] space-y-6">
          <p className="text-[#5C4D43] text-sm">Ultima actualizacion: Abril 2026</p>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">1. Datos Identificativos del Titular</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              En cumplimiento del articulo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la
              Sociedad de la Informacion y Comercio Electronico (LSSI-CE), se informa a los usuarios
              sobre los datos del titular del sitio web <strong>www.tajmahalsanfernando.es</strong>:
            </p>
            <ul className="list-none pl-0 text-[#5C4D43] mt-3 space-y-1">
              <li><strong>Titular:</strong> Talwinder Singh Kaur (empresaria autonoma)</li>
              <li><strong>NIF:</strong> 78317925G</li>
              <li><strong>Nombre comercial:</strong> Taj Mahal San Fernando</li>
              <li><strong>Domicilio:</strong> Calle Real 109, San Fernando, Cadiz 11100, España</li>
              <li><strong>Telefono:</strong> +34 602 704 745 / +34 856 044 420</li>
              <li><strong>Email:</strong> Tajmahalsafernando@gmail.com</li>
              <li><strong>Actividad:</strong> Restaurante de cocina india y venta online de comida preparada</li>
            </ul>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">2. Objeto</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              El presente Aviso Legal regula el uso del sitio web <strong>www.tajmahalsanfernando.es</strong>
              (en adelante, el Sitio Web), cuyo titular es Dña. Talwinder Singh Kaur, que opera bajo el nombre
              comercial Taj Mahal San Fernando. La utilizacion del Sitio Web atribuye la condicion de Usuario
              e implica la aceptacion plena de todas las clausulas incluidas en este Aviso Legal, asi como la
              Politica de Privacidad, Politica de Cookies, Terminos y Condiciones y Politica de Reembolsos.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">3. Condiciones de Uso</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              El Usuario se compromete a hacer un uso adecuado y licito del Sitio Web, de conformidad con la
              legislacion aplicable, el presente Aviso Legal, la moral, el orden publico y las buenas costumbres.
              Queda prohibido cualquier uso del Sitio Web con fines ilicitos o que pueda causar dano a Taj Mahal
              San Fernando o a terceros.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">4. Propiedad Intelectual e Industrial</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              Todos los contenidos del Sitio Web (incluidos textos, imagenes, logotipos, diseño grafico, codigo
              fuente, nombre comercial, marcas y cualesquiera otros signos distintivos) son propiedad de Taj Mahal
              San Fernando o de sus legitimos titulares y estan protegidos por la normativa vigente en materia de
              propiedad intelectual e industrial. Queda expresamente prohibida su reproduccion, distribucion,
              comunicacion publica o transformacion sin autorizacion previa por escrito del titular.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">5. Exclusion de Garantias y Responsabilidad</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              La titular no se responsabiliza de los daños o perjuicios de cualquier naturaleza que
              puedan deberse a la falta de disponibilidad o continuidad del funcionamiento del Sitio Web, a la
              defraudacion de la utilidad que los Usuarios hubieren podido atribuir al mismo, ni en particular,
              aunque no de modo exclusivo, a los fallos en el acceso a las distintas paginas web o desde las que,
              en su caso, se presten los servicios. Se realizan todos los esfuerzos razonables para garantizar
              que la informacion proporcionada es correcta y esta actualizada.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">6. Enlaces a Terceros</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              El Sitio Web puede contener enlaces a sitios web de terceros (Google Maps, WhatsApp, redes sociales,
              pasarelas de pago). La titular no asume ninguna responsabilidad por el contenido o los
              servicios de los sitios web enlazados, que se rigen por sus propias condiciones de uso y politicas
              de privacidad.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">7. Legislacion Aplicable y Jurisdiccion</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              Las presentes condiciones se rigen por la legislacion española. Para la resolucion de cualquier
              controversia que pudiera derivarse del acceso o uso del Sitio Web, la titular y el
              Usuario se someten a los Juzgados y Tribunales de San Fernando (Cadiz), con renuncia expresa a
              cualquier otro fuero que pudiera corresponderles, salvo que la ley aplicable imponga otro fuero
              imperativo, en particular cuando el Usuario tenga la condicion de consumidor.
            </p>
            <p className="text-[#5C4D43] leading-relaxed mt-3">
              De conformidad con el Reglamento (UE) 524/2013, el Usuario con la condicion de consumidor puede
              recurrir a la plataforma de Resolucion de Litigios en Linea de la Union Europea:{' '}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#C44536] underline">
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">8. Contacto</h2>
            <p className="text-[#5C4D43]">
              Para cualquier consulta relacionada con el presente Aviso Legal o el Sitio Web:<br />
              Email: <strong>Tajmahalsafernando@gmail.com</strong><br />
              Telefono: <strong>+34 602 704 745</strong>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LegalNoticePage;
